export default "__VITE_ASSET__mXR10oQ6__"